import { render, staticRenderFns } from "./StoryEdit.vue?vue&type=template&id=b9f57544&scoped=true"
import script from "./StoryEdit.vue?vue&type=script&lang=js"
export * from "./StoryEdit.vue?vue&type=script&lang=js"
import style0 from "./StoryEdit.vue?vue&type=style&index=0&id=b9f57544&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9f57544",
  null
  
)

export default component.exports